import ImportLangRepository from "@/repositories/loinc/ImportLangRepository";
import makeState from "@/storages/Base/State";

export default {
    name: 'Lang',
    namespaced: true,
    state: {
        created: makeState(),
        updated: makeState()
    },
    getters: {
        allCreated(state) {
            return state.created.list
        },
        isLoadingCreated(state) {
            return state.created.isLoading
        },
        paginationCreated(state) {
            return state.created.pagination
        },
        allUpdated(state) {
            return state.updated.list
        },
        isLoadingUpdated(state) {
            return state.updated.isLoading
        },
        paginationUpdated(state) {
            return state.created.pagination
        }
    },
    mutations: {
        setAllCreated(state, array) {
            state.created.list = array
        },
        setPaginationCreated(state, obj) {
            state.created.pagination = obj
        },
        setLoadingCreated(state, boolean) {
            state.created.isLoading = boolean
        },
        setAllUpdated(state, array) {
            state.updated.list = array
        },
        setPaginationUpdated(state, obj) {
            state.updated.pagination = obj
        },
        setLoadingUpdated(state, boolean) {
            state.updated.isLoading = boolean
        }
    },
    actions: {
        async listAllCreated({commit}, params) {
            commit('setLoadingCreated', true)
            await ImportLangRepository.fetchAllCreated(params).then(response => {
                commit('setAllCreated', response.data.data)
                commit('setPaginationCreated', {
                    per_page: response.data.per_page,
                    page: response.data.current_page,
                    total: response.data.total
                })
            })
            commit('setLoadingCreated', false)
        },
        async listAllUpdated({commit}, params) {
            commit('setLoadingUpdated', true)
            await ImportLangRepository.fetchAllUpdated(params).then(response => {
                commit('setAllUpdated', response.data.data)
                commit('setPaginationUpdated', {
                    per_page: response.data.per_page,
                    page: response.data.current_page,
                    total: response.data.total
                })
            })
            commit('setLoadingUpdated', false)
        },
        async resetAll({commit}, params) {
            const pagination = {
                per_page: 10,
                page: 1,
                total: 0
            }
            await commit('setPaginationCreated', pagination)
            await commit('setPaginationUpdated', pagination)
            await commit('setAllCreated', [])
            await commit('setAllUpdated', [])
        }
    }
}
